import { Chat } from '@/config'
import { ChatListUsersFilters, ChatUser } from '@packages/chat'
import { QueryManager } from '@codeleap/query'
import { queryClient } from '../queryClient'

export const usersManager = new QueryManager<ChatUser>({
  itemType: {} as ChatUser,
  name: 'chatUsers',
  queryClient: queryClient.client,
  limit: 20,

  listItems: async (limit, offset, filters: ChatListUsersFilters) => {
    const response = await Chat.API.listUsers({
      limit,
      offset,
      ...filters,
    })
    if (response.ok) return response.data
    return null
  },

  retrieveItem: async (id: ChatUser['id']) => {
    const response = await Chat.API.retrieveUser(id)
    if (response.ok) return response.data
    return null
  },
})
